/**
 * /payment and /p — Direct payment / activate entry points.
 *
 * Used by:
 *   - Demo drip campaign WhatsApp/Email links
 *   - Direct CTA campaigns
 *
 * Behavior:
 *   - If user is logged in (demo or paid): redirect to dashboard with ?activate=1
 *   - If not logged in: redirect to landing page with payment modal flag
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentRedirectPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    try {
      const token = localStorage.getItem('token');
      const userRaw = localStorage.getItem('user');
      const user = userRaw ? JSON.parse(userRaw) : null;

      if (token && user) {
        // Logged-in user: send straight to the UDISE trial activation page.
        if (user.role === 'platform_admin') {
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/activate', { replace: true });
        }
      } else {
        // Anonymous: jump to landing page with payment modal flag
        navigate('/?activate=1#pricing', { replace: true });
      }
    } catch {
      timer = setTimeout(() => navigate('/?activate=1#pricing', { replace: true }), 200);
    }
    return () => timer && clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 via-amber-50 to-rose-50"
      data-testid="payment-redirect-page"
    >
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-orange-500 border-t-transparent mb-4"></div>
        <p className="text-slate-700 font-medium">Redirecting to activate page…</p>
        <p className="text-xs text-slate-500 mt-2">🚀 शिक्षा मित्र</p>
      </div>
    </div>
  );
}
